// @react/hooks/usePaymentPaymentMethod.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { paymentPaymentMethodStore } from '@core/stores';

/**
 * React hook for PaymentMethodDetail operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { usePaymentPaymentMethod } from '@react/hooks';
 *
 * const PaymentMethodDetailList = observer(() => {
 *   const store = usePaymentPaymentMethod();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function usePaymentPaymentMethod() {
  return paymentPaymentMethodStore;
}
